import { IllustExtension } from "../../../../../models/tieup/illustration/IllustExtension"
import { Genre } from "../../../../../models/genre/Genre"
import { HashTag } from "../../../../../models/tieup/HashTag"
import { IllustrationData } from "../../../../../models/tieup/illustration/IllustrationData"
import { EditIllustrationData } from "../../../../../models/tieup/illustration/EditlIllustrationData"

export type IllustrationFormModel = {
  is_grotesque: boolean
  rating: string
  is_sexual: boolean
  is_violence: boolean
  original_genres: string
  outline_text?: string
  status: "true" | "false"
  title: string
  extension: IllustExtension
  genres: Genre[]
  hashtags: HashTag[]
}

export const makeFormModel = (v: IllustrationData): IllustrationFormModel => {
  const rating = (() => {
    if (v.is_r18) {
      return "r18"
    }
    if (v.is_r15) {
      return "r15"
    }

    return "all"
  })()

  return {
    is_grotesque: v.is_grotesque || false,
    rating: rating,
    is_sexual: v.is_sexual || false,
    is_violence: v.is_violence || false,
    original_genres: v.original_genres || "",
    outline_text: v.outline_text,
    status: v.status ? "true" : "false",
    title: v.title || "",
    extension: v.extension,
    genres: v.genres || [],
    hashtags: v.hashtags || [],
  }
}

export const makeEditIllustrationData = (
  v: IllustrationFormModel,
): EditIllustrationData => {
  const is_r18 = v.rating === "r18"
  const is_r15 = v.rating === "r15"

  return {
    ...v,
    status: v.status === "true",
    outline_text: v.outline_text || "",
    is_r18,
    is_r15,
  }
}
